import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';
import { MfaLoginResponse } from '@store/rtk/auth';

export const loginApi = createApi({
  reducerPath: 'Login',
  tagTypes: ['Login'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    login: builder.mutation<
      MfaLoginResponse | undefined,
      { body: { email: string; password: string } }
    >({
      query: ({ body: { email, password } }) => {
        return {
          url: `/auth/login`,
          method: 'POST',
          body: { email, password },
        };
      },
    }),
    loginWithUserInfoInRes: builder.mutation({
      query: ({ body: { email, password } }) => {
        return {
          url: '/v1/users/info/supervisor',
          method: 'POST',
          body: { email, password },
        };
      },
    }),
  }),
});

export const { useLoginMutation, useLoginWithUserInfoInResMutation } = loginApi;
